import React from 'react';
import { Box, CircularProgress, Typography, Fade } from '@mui/material';

const LoadingAnimation = ({ loading, message = "Маълумотлар юкланмоқда..." }) => {
  return (
    <Fade in={loading} timeout={500}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: 200,
          gap: 2,
        }}
      >
        <CircularProgress 
          size={60} 
          thickness={4}
          color="primary"
          sx={{
            animationDuration: '1.5s',
          }}
        />
        <Typography variant="body1" color="text.secondary">
          {message}
        </Typography>
      </Box>
    </Fade>
  );
};

export default LoadingAnimation;